var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "213.68 321.72 212.76 327.35 211.78 333.4 202.78 388.57 188.07 388.57 197.06 333.4 198.05 327.35 198.97 321.72 213.68 321.72",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.55,321.72c-.78,5.59-1.61,11.17-2.45,16.74l-2.6,16.73-2.72,16.7-1.4,8.34-1.46,8.34,1.2-8.38,1.25-8.37L206,355.1l2.72-16.7C209.61,332.83,210.55,327.27,211.55,321.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.76 327.35 211.78 333.4 197.06 333.4 198.05 327.35 212.76 327.35",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.32 321.72 287.24 327.35 288.22 333.4 297.22 388.57 311.93 388.57 302.94 333.4 301.95 327.35 301.03 321.72 286.32 321.72",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,321.72c.77,5.59,1.61,11.17,2.45,16.74l2.59,16.73,2.72,16.7,1.41,8.34,1.46,8.34-1.2-8.38-1.25-8.37-2.6-16.72-2.72-16.7C290.43,332.83,289.49,327.27,288.5,321.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.24 327.35 301.95 327.35 302.94 333.4 288.22 333.4 287.24 327.35",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.14 306.2 201.48 306.2 202.93 295.32 211.69 295.32 213.14 306.2",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.31,
    cy: 287.55,
    r: 10.87,
    transform: "translate(-111.89 441.74) rotate(-79.99)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.31,
    cy: 287.55,
    r: 8.27,
    transform: "translate(-120.29 422.98) rotate(-76.67)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22,287.07a7.18,7.18,0,0,0-2.7-5.07,7.29,7.29,0,0,0-5.56-1.45,7,7,0,0,0-4.78,3.1,7.33,7.33,0,0,0-.87,6,6.86,6.86,0,0,0,3.23,4.09,7.2,7.2,0,0,0,5.06.78,7.47,7.47,0,0,0,4.24-2.6,7.88,7.88,0,0,0,1.75-4.61c0-.07,0-.14-.07-.14s-.07.06-.07.14a7.47,7.47,0,0,1-.39,2,8.45,8.45,0,0,1-.91,1.8,8.66,8.66,0,0,1-1.36,1.48,8.5,8.5,0,0,1-1.71,1.11,7,7,0,0,1-5.65.14,6.78,6.78,0,0,1-3.82-4.2,7,7,0,0,1,.72-5.79,6.72,6.72,0,0,1,4.65-3.06,7.21,7.21,0,0,1,6.85,2.73,7.49,7.49,0,0,1,.92,1.72,8.25,8.25,0,0,1,.44,1.92s0,0,0,0S214.22,287.1,214.22,287.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.25,287.08a6.16,6.16,0,0,0-2.34-4.33,6.37,6.37,0,0,0-4.75-1.26,6,6,0,0,0-4.13,2.64,6.32,6.32,0,0,0-.8,5.16,5.87,5.87,0,0,0,2.8,3.57,6.15,6.15,0,0,0,4.41.66,6.44,6.44,0,0,0,3.67-2.27,6.85,6.85,0,0,0,1.51-4c0-.06,0-.12-.06-.12s-.08.05-.08.12a6.59,6.59,0,0,1-3.78,5.51,5.93,5.93,0,0,1-4.88.14,5.84,5.84,0,0,1-3.3-3.64,6,6,0,0,1,.66-5,5.68,5.68,0,0,1,4-2.58A6.23,6.23,0,0,1,212,284a6.68,6.68,0,0,1,.8,1.46,8,8,0,0,1,.39,1.64s0,0,0,0A0,0,0,0,0,213.25,287.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.28,287.09a5.2,5.2,0,0,0-2-3.59,5.4,5.4,0,0,0-3.94-1.06,5,5,0,0,0-3.49,2.16,5.33,5.33,0,0,0-.73,4.37,4.93,4.93,0,0,0,2.37,3.06,5.3,5.3,0,0,0,3.77.54,5.46,5.46,0,0,0,3.1-2,6,6,0,0,0,1.28-3.37c0-.06,0-.11-.07-.11a.09.09,0,0,0-.08.1,5.64,5.64,0,0,1-3.18,4.64,5,5,0,0,1-4.12.14,4.85,4.85,0,0,1-2.79-3.08,5.08,5.08,0,0,1,.6-4.19,4.76,4.76,0,0,1,3.37-2.1,5.79,5.79,0,0,1,2.66.31,5,5,0,0,1,2.17,1.6,5.24,5.24,0,0,1,.68,1.2,6.17,6.17,0,0,1,.35,1.36l0,0S212.29,287.1,212.28,287.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.32,287.1a4.32,4.32,0,0,0-1.63-2.85,4.44,4.44,0,0,0-3.13-.86,4.07,4.07,0,0,0-2.85,1.69,4.39,4.39,0,0,0-.66,3.57,4,4,0,0,0,1.95,2.54,4.37,4.37,0,0,0,3.12.43,4.55,4.55,0,0,0,2.53-1.64,5,5,0,0,0,1-2.76.08.08,0,0,0-.07-.09s-.07,0-.08.08A4.67,4.67,0,0,1,209,291a4,4,0,0,1-3.36.16,3.91,3.91,0,0,1-2.27-2.54,4.08,4.08,0,0,1,.54-3.38,3.8,3.8,0,0,1,2.72-1.63,4.89,4.89,0,0,1,2.1.27,4.07,4.07,0,0,1,1.73,1.23,4.71,4.71,0,0,1,.55.95,5.3,5.3,0,0,1,.31,1.09h0A0,0,0,0,0,211.32,287.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.27 306.2 286.6 306.2 288.05 295.32 296.82 295.32 298.27 306.2",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.44,
    cy: 287.55,
    r: 10.87,
    transform: "matrix(0.15, -0.99, 0.99, 0.15, -35.94, 533.26)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.44,
    cy: 287.55,
    r: 8.27,
    transform: "translate(-35.92 533.3) rotate(-81.33)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.35,287.07a7.21,7.21,0,0,0-2.7-5.07,7.3,7.3,0,0,0-5.56-1.45,7,7,0,0,0-4.78,3.1,7.26,7.26,0,0,0-.87,6,6.82,6.82,0,0,0,3.23,4.09,7.19,7.19,0,0,0,5.06.78,7.47,7.47,0,0,0,4.24-2.6,7.88,7.88,0,0,0,1.75-4.61c0-.07,0-.14-.07-.14s-.07.06-.08.14a7.87,7.87,0,0,1-.38,2,8,8,0,0,1-.92,1.8,7.87,7.87,0,0,1-3.07,2.59,6.93,6.93,0,0,1-5.64.14,6.79,6.79,0,0,1-3.83-4.2,7,7,0,0,1,.73-5.79,6.72,6.72,0,0,1,4.65-3.06,7.21,7.21,0,0,1,6.85,2.73,7.9,7.9,0,0,1,.92,1.72,8.23,8.23,0,0,1,.43,1.92s0,0,0,0S299.35,287.1,299.35,287.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.38,287.08a6.24,6.24,0,0,0-2.34-4.33,6.37,6.37,0,0,0-4.75-1.26,6,6,0,0,0-4.14,2.64,6.32,6.32,0,0,0-.8,5.16,5.87,5.87,0,0,0,2.8,3.57,6.17,6.17,0,0,0,4.41.66,6.44,6.44,0,0,0,3.68-2.27,6.92,6.92,0,0,0,1.51-4c0-.06,0-.12-.07-.12s-.07.05-.08.12a6.58,6.58,0,0,1-3.77,5.51,5.93,5.93,0,0,1-4.88.14,5.83,5.83,0,0,1-3.31-3.64,6.05,6.05,0,0,1,.66-5,5.72,5.72,0,0,1,4-2.58,6.22,6.22,0,0,1,5.84,2.32,6.29,6.29,0,0,1,.8,1.46,6.89,6.89,0,0,1,.39,1.64s0,0,0,0A.07.07,0,0,0,298.38,287.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.41,287.09a5.28,5.28,0,0,0-2-3.59,5.42,5.42,0,0,0-3.94-1.06A5,5,0,0,0,288,284.6a5.37,5.37,0,0,0-.74,4.37,5,5,0,0,0,2.38,3.06,5.28,5.28,0,0,0,3.76.54,5.49,5.49,0,0,0,3.11-2,5.9,5.9,0,0,0,1.27-3.37c0-.06,0-.11-.06-.11a.09.09,0,0,0-.08.1,5.66,5.66,0,0,1-3.18,4.64,5,5,0,0,1-4.12.14,4.85,4.85,0,0,1-2.79-3.08,5.08,5.08,0,0,1,.6-4.19,4.72,4.72,0,0,1,3.36-2.1,5.81,5.81,0,0,1,2.67.31,5,5,0,0,1,2.17,1.6,5.24,5.24,0,0,1,.68,1.2,7.53,7.53,0,0,1,.35,1.36l0,0A.06.06,0,0,0,297.41,287.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.44,287.1a4.27,4.27,0,0,0-1.62-2.85,4.45,4.45,0,0,0-3.13-.86,4,4,0,0,0-2.85,1.69,4.39,4.39,0,0,0-.66,3.57,4,4,0,0,0,1.95,2.54,4.35,4.35,0,0,0,3.11.43,4.61,4.61,0,0,0,2.54-1.64,5,5,0,0,0,1-2.76.07.07,0,0,0-.06-.09.08.08,0,0,0-.08.08,4.66,4.66,0,0,1-2.59,3.76,4,4,0,0,1-3.35.16,3.91,3.91,0,0,1-2.27-2.54,4.08,4.08,0,0,1,.54-3.38,3.79,3.79,0,0,1,2.72-1.63,4.85,4.85,0,0,1,2.09.27,4,4,0,0,1,1.73,1.23,4.32,4.32,0,0,1,.56.95,5.3,5.3,0,0,1,.31,1.09h0S296.45,287.11,296.44,287.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.69,
    y: 300.66,
    width: 146.61,
    height: 28.04,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.83 300.66 196.19 328.7 177.25 328.7 187.89 300.66 206.83 300.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.64 300.66 235 328.7 216.06 328.7 226.7 300.66 245.64 300.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.44 300.66 273.81 328.7 254.87 328.7 265.51 300.66 284.44 300.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.26 300.66 312.62 328.7 293.68 328.7 304.32 300.66 323.26 300.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.66,
    y: 354.63,
    width: 140.68,
    height: 17.75,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.57 354.63 198.37 372.37 180.2 372.37 190.41 354.63 208.57 354.63",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.82 354.63 235.61 372.37 217.43 372.37 227.64 354.63 245.82 354.63",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.05 354.63 272.84 372.37 254.67 372.37 264.88 354.63 283.05 354.63",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.29 354.63 310.08 372.37 291.91 372.37 302.12 354.63 320.29 354.63",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.8,167.11H354.62s11.22-30.65,28.49-30.65,22.68,21.15,22.68,21.15,11.65-11.49,21.23-11.49,17.89,15.19,17.89,15.19S458.44,153.14,467.8,167.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.47,95.22H111.58S123.39,78.1,132.71,78.1s12.06,11.41,12.06,11.41,6.57-5.32,12.66-4.37S164.47,95.22,164.47,95.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.78,218.51H396.89s11.82-17.12,21.13-17.12,12.06,11.41,12.06,11.41,6.57-5.33,12.66-4.37S449.78,218.51,449.78,218.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.23,138.13H32.2s14.11-31.5,29.2-33.47,22.31,23.4,22.31,23.4,9.74-9,17.39-9,13.56,11.81,13.56,11.81S130,122.81,135.23,138.13Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "35.91 388.82 88.93 388.58 141.96 388.49 248 388.32 354.05 388.49 407.07 388.58 460.09 388.82 407.07 389.06 354.05 389.15 248 389.32 141.96 389.15 88.93 389.06 35.91 388.82",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-58"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 443.14,
    rx: 210.09,
    ry: 24.49,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.47,447.71c2.08.7,61.62.91,63.9-.52.87-.54,1.4-9.21,1.75-19.7.08-2.27.14-4.61.2-7l4.82-31.75-39.8-.26-3.76,31.77.15,7s-22.83,10.12-25.16,11.95S275.4,447,277.47,447.71Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.47,447.71c2.08.7,61.62.91,63.9-.52,1.05-.66,1.63-13.32,1.95-26.69l-38.74-.24.15,7s-22.83,10.12-25.16,11.95S275.4,447,277.47,447.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.47,447.71c2.08.7,61.62.91,63.9-.52.87-.54,1.4-9.21,1.75-19.7l-38.39-.25s-22.83,10.12-25.16,11.95S275.4,447,277.47,447.71Z",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,445.33c10-.21,50.26-.12,60.14.43.08,0,.08.06,0,.07-9.89.42-50.17,0-60.15-.34C278.12,445.48,278.13,445.33,278.34,445.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.41,437.06a8,8,0,0,1,6,2.46,7.8,7.8,0,0,1,2.22,5.34c0,.06-.12.06-.13,0a9.25,9.25,0,0,0-8-7.67A.07.07,0,0,1,283.41,437.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.86,428.22c4,0,8.62,1.39,11.09,4.66.1.13-.08.26-.2.2a55.82,55.82,0,0,0-11-4.37A.25.25,0,0,1,300.86,428.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.77,429.41c4,0,8.62,1.39,11.09,4.67.1.12-.08.26-.2.19a54.93,54.93,0,0,0-11-4.36A.26.26,0,0,1,297.77,429.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.68,430.61c4-.05,8.62,1.38,11.1,4.66.09.12-.09.26-.21.2a54.37,54.37,0,0,0-11-4.37A.25.25,0,0,1,294.68,430.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.59,431.8c4,0,8.63,1.38,11.1,4.66.09.12-.09.26-.21.2a54.37,54.37,0,0,0-11-4.37A.25.25,0,0,1,291.59,431.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,436.27c4.49,0,4.45,7,0,7S331.48,436.24,336,436.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.88,423.4c2.14,2.79,5.42,4.56,8.26,6.53a.49.49,0,0,0,.72-.32.1.1,0,0,0,.12-.11,20.94,20.94,0,0,0-3.59-10.23c-1.24-1.75-3.78-3.39-5.81-1.72S295.62,421.78,296.88,423.4Zm-.18-3.31c.42-4.34,4.33-1,5.19.33a23.37,23.37,0,0,1,1.45,2.7,63.2,63.2,0,0,1,2.23,5.93c-1.33-1.06-2.75-2-4.12-3C299.82,424.86,296.48,422.49,296.7,420.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.18,427c-.3-2.61-3.28-3.18-5.38-2.79a21.06,21.06,0,0,0-9.68,4.88.1.1,0,0,0,0,.17.48.48,0,0,0,.29.73c3.42.54,7,1.55,10.49,1C317.94,430.71,320.47,429.47,320.18,427Zm-9.41,2.75c-1.69-.22-3.35-.53-5-.69,1.89-.95,3.73-2,5.71-2.73a23.09,23.09,0,0,1,2.92-.94c1.54-.35,6.68-.06,4,3.36C316.83,430.63,312.78,430,310.77,429.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.64,241.94s-46.23,78.64-47.47,84.16c-1.9,8.49-12,92.27-12,92.27l-48.1-.86s8.29-73.88,16.14-98.21c5.66-17.53,46.45-75.67,46.45-75.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,410.13c6.91-.05,31.39-.32,40.58.53a.07.07,0,0,1,0,.14c-3.16.45-33.67-.26-40.58-.48A.1.1,0,1,1,303.46,410.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.75,249.16c-3,4.75-6.23,9.4-9.33,14.11s-6.18,9.43-9.23,14.18q-9.13,14.22-17.84,28.7a88.42,88.42,0,0,0-7.21,14,86,86,0,0,0-4.05,15.09c-.95,5.17-1.57,10.38-2.15,15.59q-.94,8.32-1.86,16.64-1.9,17-3.8,34.06c-.16,1.39-.31,2.79-.45,4.18,0,.21.34.25.37,0,1.41-11.28,2.59-22.59,3.88-33.89L349,355c.59-5.23,1.16-10.46,2-15.67a103.76,103.76,0,0,1,3.39-15.14A72.39,72.39,0,0,1,361,309.48c5.57-9.61,11.47-19.06,17.37-28.48s11.95-19,18.18-28.33c.76-1.15,1.54-2.3,2.34-3.43C399,249.15,398.81,249.07,398.75,249.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77,454.32c2.19.14,61.27-15.43,63.11-17.39a.82.82,0,0,0,.14-.4c.23-1.94-2.79-9.19-4.91-18.48-.13-.59-1.24-3.41-2.8-7.22-4.29-10.45-11.94-28.41-11.94-28.41l-38.57,9.9L385,420.87l1.92,6.71s-19.51,15.61-21.29,18S363.59,454.16,365.77,454.32Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77,454.32c2.19.14,61.27-15.43,63.11-17.39a.82.82,0,0,0,.14-.4c.23-1.94-2.79-9.19-4.91-18.48-.13-.59-1.24-3.41-2.8-7.22l-36.3,10,1.92,6.71s-19.51,15.61-21.29,18S363.59,454.16,365.77,454.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77,454.31c2.19.16,61.27-15.42,63.11-17.38.7-.74-.83-8.73-4.77-18.88l-37.18,9.54s-19.51,15.59-21.29,18S363.59,454.16,365.77,454.31Z",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,451.79c9.6-2.74,48.58-12.9,58.28-14.89.08,0,.09,0,0,.07-9.45,2.92-48.51,12.77-58.25,15C365.84,452,365.8,451.85,366,451.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.81,442.51a8,8,0,0,1,6.39.86,7.81,7.81,0,0,1,3.5,4.6c0,.06-.1.09-.12,0a9.26,9.26,0,0,0-9.74-5.37A.06.06,0,1,1,368.81,442.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,429.52c3.85-1.06,8.69-.86,11.91,1.68.13.1,0,.28-.14.25A55,55,0,0,0,383.49,430,.25.25,0,0,1,383.43,429.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.75,431.46c3.85-1.06,8.69-.86,11.91,1.68.13.1,0,.28-.15.25A54.85,54.85,0,0,0,380.8,432,.25.25,0,0,1,380.75,431.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.06,433.4c3.86-1.06,8.69-.86,11.92,1.68.12.1,0,.27-.15.25a54.85,54.85,0,0,0-11.71-1.44A.25.25,0,0,1,378.06,433.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.38,435.33c3.85-1.05,8.69-.85,11.91,1.69.13.1,0,.27-.14.24a55.65,55.65,0,0,0-11.71-1.43A.25.25,0,0,1,375.38,435.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.44,428.37c4.34-1.12,6.08,5.63,1.73,6.74S415.09,429.48,419.44,428.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.35,425.87c2.79,2.15,6.41,3,9.65,4.21a.49.49,0,0,0,.62-.49.1.1,0,0,0,.09-.14,21,21,0,0,0-6.08-9c-1.64-1.37-4.52-2.32-6.06-.18S376.73,424.62,378.35,425.87Zm-1-3.15c-.7-4.31,3.93-2.06,5.1-1a22.16,22.16,0,0,1,2.09,2.24,60.24,60.24,0,0,1,3.67,5.16c-1.56-.68-3.17-1.22-4.75-1.85C381.56,426.53,377.73,425.09,377.34,422.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.8,423.42c-.95-2.45-4-2.24-5.91-1.32a20.91,20.91,0,0,0-8.12,7.18.1.1,0,0,0,.05.16.49.49,0,0,0,.47.63c3.45-.35,7.17-.29,10.4-1.68C400.58,427.58,402.71,425.73,401.8,423.42Zm-8.4,5.06c-1.68.21-3.37.34-5,.61a62.51,62.51,0,0,1,4.83-4.09,23.46,23.46,0,0,1,2.58-1.65c1.4-.74,6.45-1.76,4.69,2.23C399.49,427.79,395.42,428.23,393.4,428.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.36,419l43.22-11.34s-41.38-81.43-41-87.05c.3-5,30.31-48.68,32-56.86,2.71-13.39-3.81-25.35-10.13-32.75l-44.7,12.6s3.56,7.73,10.1,12.61c0,0-28.09,46.9-28.81,62.34S382.36,419,382.36,419Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.54,411c6.26-1.79,4.44-1.36,10.73-3.09,3.08-.84,23.31-6.37,26.31-6.66.07,0,.1.1,0,.13-2.76,1.24-23.08,6.42-26.17,7.2-6.32,1.6-4.53,1.07-10.87,2.61C381.47,411.2,381.42,411,381.54,411Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.92,254.44a79.87,79.87,0,0,1,12.37,5.84.13.13,0,1,1-.12.24c-4.17-1.82-8.43-3.56-12.49-5.6A.27.27,0,0,1,364.92,254.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.17,253.34a20,20,0,0,1,.8,2.41,5.15,5.15,0,0,1,.31,2,.15.15,0,0,1-.26,0,7.07,7.07,0,0,1-.84-1.93c-.27-.75-.56-1.49-.8-2.24C369.21,253.1,370,252.86,370.17,253.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.17,249.29c-.18-.69-.36-1.37-.55-2.06s-.45-1.4-.59-2.12c0-.11-.2-.06-.17,0,.17.69.25,1.41.37,2.11s.26,1.4.4,2.09a37.38,37.38,0,0,0,1,3.88,4.72,4.72,0,0,1-2-.61,3.7,3.7,0,0,1-1.22-1.91c-.28-.78-.53-1.57-.82-2.34a16.27,16.27,0,0,1-.86-2.61c0-.12-.2-.07-.18,0a28.68,28.68,0,0,0,1.59,5.51c.31.7.54,1.42,1.23,1.76a5.94,5.94,0,0,0,2.4.47c.09,0,.23,0,.21-.13C370.77,252.05,370.51,250.64,370.17,249.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.91,257.77c-1.7,3.07-3.64,6-5.46,9s-3.46,5.92-5.12,8.92c-3.34,6.06-6.44,12.28-9.27,18.6q-2.1,4.69-4,9.49a71.67,71.67,0,0,0-3.25,9.8,26.84,26.84,0,0,0-.44,10.18A69.69,69.69,0,0,0,346.05,334a181.6,181.6,0,0,0,8.44,22.42c.11.24.51.06.42-.19-2.36-6.66-4.8-13.3-6.93-20-2.05-6.54-4.49-13.32-3.36-20.27a52.81,52.81,0,0,1,2.84-9.75q1.82-4.86,3.88-9.61c2.72-6.25,5.76-12.32,8.88-18.37,1.74-3.39,3.57-6.74,5.34-10.12s3.51-6.88,5.5-10.16C371.12,257.76,371,257.68,370.91,257.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.46,251.21c-.81-.13-2,.15-5.49-.09a19.88,19.88,0,0,1-2.88-.47,6.34,6.34,0,0,1-2.67-1.08,14.11,14.11,0,0,1-3.05-4.2,21.26,21.26,0,0,1-2.13-5.18c0-.11-.19-.06-.17.05.19,1,.29,2,.56,3.06a18.13,18.13,0,0,0,1,2.78,11.34,11.34,0,0,0,3.13,4.62c1.58,1.19,3.79,1.41,5.7,1.55,1.11.08,5.46,0,6-.66C403.62,251.48,403.61,251.24,403.46,251.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.85,398.36q-8.18-16.62-16-33.45T383.67,331a44.29,44.29,0,0,1-3.23-8.37c-.67-3.17.31-6,1.65-8.87a151.81,151.81,0,0,1,8.35-15.15c3-4.92,6.24-9.73,9.41-14.56a151,151,0,0,0,9-14.72c2.46-4.91,3.83-10.14,3.13-15.64s-3.07-10.58-5.6-15.41c-.67-1.27-1.36-2.53-2-3.81-.05-.09-.2,0-.14.09,2.82,5.06,5.53,10.37,6.85,16a26.09,26.09,0,0,1,.62,8.58,27.19,27.19,0,0,1-2.42,8.37c-2.35,5.16-5.63,9.92-8.72,14.65s-6.38,9.65-9.46,14.55a169.06,169.06,0,0,0-8.61,15.17c-1.14,2.33-2.39,4.76-2.67,7.37-.3,2.87.73,5.61,1.84,8.2,4.8,11.26,9.86,22.43,15,33.54s10.47,22.26,15.88,33.3l2,4.17C414.68,398.69,414.93,398.53,414.85,398.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.76,147.6c1-4.57,6.08-14.91,16.11-12.89,14.32,2.89,16.39,30.48,23.52,39.08,12.91,15.58,13.33,31,2.75,33.47-11.86,2.76-23.4-10-23-37.5.27-17.22-4.58-24.85-8-24.34s-5.31,4.86-5.31,4.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.24,145.89a27.84,27.84,0,0,1,2.87-6.07,16.49,16.49,0,0,1,4.68-4.92,11.23,11.23,0,0,1,6.62-1.92,14.45,14.45,0,0,1,6.65,1.85,16.12,16.12,0,0,1,5,4.69,29.73,29.73,0,0,1,3.21,6,60.08,60.08,0,0,1,3.32,13,88.61,88.61,0,0,0-4.22-12.59,31.79,31.79,0,0,0-3.27-5.67,15.19,15.19,0,0,0-4.7-4.3,13.42,13.42,0,0,0-6.07-1.75,10.45,10.45,0,0,0-6,1.56,16.85,16.85,0,0,0-4.71,4.44,28.68,28.68,0,0,0-1.83,2.76C362.23,143.89,361.72,144.88,361.24,145.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.09,160.27c.15,2.73,0,5.47-.06,8.2s-.17,5.45-.18,8.17.08,5.43.36,8.12a41.31,41.31,0,0,0,1.46,7.91,21,21,0,0,0,3.49,7.1,22.77,22.77,0,0,0,6,5.19,17,17,0,0,0,7.55,2.42,15.5,15.5,0,0,0,4-.21,14.9,14.9,0,0,0,2-.52,7,7,0,0,0,1.84-.85,10.11,10.11,0,0,1-3.73,1.69,15.8,15.8,0,0,1-4.11.51,17,17,0,0,1-4.14-.59,18.12,18.12,0,0,1-3.87-1.59,21.55,21.55,0,0,1-3.46-2.36l-.79-.68-.76-.71a15.21,15.21,0,0,1-1.44-1.56,22.06,22.06,0,0,1-3.76-7.48,52.64,52.64,0,0,1-1.58-16.41c.08-2.74.29-5.47.53-8.19S380,163,380.09,160.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.94,147.68c-.16-1.27.61-3,1.41-3.31s7.18,1.74,7.85,3.27-1.91,3.16-1.91,3.16Z",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.58,192.72c-3.93,5.61-32.35,28.82-47.85,29.68-7,.38-34.38-2.6-40.48-5.11-7.49-3.08,7.32-21.63,12-20.84,5.86,1,26.64,3.19,30.78,3.3,6.64.17,27-11,40.71-13.91C369.83,184.35,370.62,188.4,367.58,192.72Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.27,193.78c-4.34,7.57-19.66,20.55-19.66,20.55L345,209.51l-8.64-15.91s14.52-5.78,24.15-8.59a21.74,21.74,0,0,1,3.46-.76C370.19,183.45,371,187.28,367.27,193.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.27,193.78c-4.34,7.57-19.66,20.55-19.66,20.55L345,209.51l-1.78-3.28-6.87-12.62s14.53-5.8,24.16-8.61a23.29,23.29,0,0,1,3.46-.75,2.46,2.46,0,0,1,.37,0C370.22,183.61,370.94,187.41,367.27,193.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.16,189.69a8.95,8.95,0,0,1,0,4.2,8.94,8.94,0,0,1,0-4.2Zm-4.11,8.24a7.81,7.81,0,0,0-2.09.25,8.24,8.24,0,0,0,2.09.25,8.37,8.37,0,0,0,2.1-.25A7.94,7.94,0,0,0,345.05,197.93Zm21.24-11.74a7.94,7.94,0,0,0-2.1.25,7.94,7.94,0,0,0,2.1.25,8.35,8.35,0,0,0,2.09-.25A8.35,8.35,0,0,0,366.29,186.19Zm-8.18,10.44a8.15,8.15,0,0,0,1.66,1.3,8.15,8.15,0,0,0-1.3-1.66,8.44,8.44,0,0,0-1.66-1.3A8.44,8.44,0,0,0,358.11,196.63Zm-8.07,10a8.2,8.2,0,0,0,1.66,1.31,7.82,7.82,0,0,0-1.3-1.66,8.2,8.2,0,0,0-1.66-1.31A7.89,7.89,0,0,0,350,206.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.28,210.78c-1.45-2.93-7.85-14.73-9.4-17.19-.11-.17-.24-.15-.16,0a181.73,181.73,0,0,0,9.44,17.19C350.2,210.9,350.32,210.86,350.28,210.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.27,193.78c-4.34,7.57-19.66,20.55-19.66,20.55L345,209.51l-1.78-3.28c8.31-8.2,18.32-18.29,21.12-22C370.22,183.61,370.94,187.41,367.27,193.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.1,228.65l2.27,25a84.45,84.45,0,0,0,9.13-.92,214.34,214.34,0,0,0,23.67-4.93c7.73-2,16.79-4.76,27.15-8.44,0,0-23.43-42.26-39.6-53.92-.37-.27-.73-.52-1.1-.75-.07-.06-.14-.09-.21-.14-7.35-4.65-14-1-17.68,4.18-.93,1.3-9.93,21.76-9.48,28.62C347.66,223.38,353.1,228.65,353.1,228.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.1,201.89a7.81,7.81,0,0,1,.25,2.09,7.94,7.94,0,0,1-.25,2.1,7.94,7.94,0,0,1-.25-2.1A8.24,8.24,0,0,1,366.1,201.89Zm5.45,26.18a8.37,8.37,0,0,0,.25,2.1,7.54,7.54,0,0,0,.25-2.1,7.94,7.94,0,0,0-.25-2.1A8.37,8.37,0,0,0,371.55,228.07ZM389,213.17a7.94,7.94,0,0,0,.25,2.1,8.94,8.94,0,0,0,0-4.2A7.94,7.94,0,0,0,389,213.17Zm-32,11.71a7.94,7.94,0,0,0,.25,2.1,8.94,8.94,0,0,0,0-4.2A7.94,7.94,0,0,0,357,224.88Zm20.16-18.43a8.37,8.37,0,0,0-2.1.25,8.95,8.95,0,0,0,4.2,0A8.37,8.37,0,0,0,377.17,206.45Zm14.88,18.65a7.54,7.54,0,0,0-2.1.25,8.95,8.95,0,0,0,4.2,0A7.94,7.94,0,0,0,392.05,225.1Zm-22.62,14.78a7.81,7.81,0,0,0-2.09.25,7.81,7.81,0,0,0,2.09.25,7.94,7.94,0,0,0,2.1-.25A8.37,8.37,0,0,0,369.43,239.88ZM395.77,237a8.3,8.3,0,0,0-2.09.25,8.9,8.9,0,0,0,4.19,0A8.37,8.37,0,0,0,395.77,237Zm-29.48-50.84a7.94,7.94,0,0,0-2.1.25,7.94,7.94,0,0,0,2.1.25,8.35,8.35,0,0,0,2.09-.25A8.35,8.35,0,0,0,366.29,186.19Zm10.7,4.63a8.2,8.2,0,0,0,1.66,1.31,7.58,7.58,0,0,0-1.3-1.66,8.2,8.2,0,0,0-1.66-1.31A8.15,8.15,0,0,0,377,190.82Zm21.85,23.39a8.2,8.2,0,0,0,1.66,1.31,7.89,7.89,0,0,0-1.3-1.66,8.48,8.48,0,0,0-1.66-1.31A8.15,8.15,0,0,0,398.84,214.21Zm-34.94,2.5a8.2,8.2,0,0,0,1.66,1.31,9,9,0,0,0-3-3A8.2,8.2,0,0,0,363.9,216.71ZM384,233.61a8.2,8.2,0,0,0,1.66,1.31,9,9,0,0,0-3-3A8.2,8.2,0,0,0,384,233.61Zm-25.84-37a8.15,8.15,0,0,0,1.66,1.3,8.15,8.15,0,0,0-1.3-1.66,8.44,8.44,0,0,0-1.66-1.3A8.44,8.44,0,0,0,358.11,196.63Zm-1.42,13.14a8.48,8.48,0,0,0,1.31-1.66,7.82,7.82,0,0,0-1.66,1.3,8.2,8.2,0,0,0-1.31,1.66A8.52,8.52,0,0,0,356.69,209.77Zm47.45,17.86a7.82,7.82,0,0,0,1.3-1.66,8.88,8.88,0,0,0-3,3A8.2,8.2,0,0,0,404.14,227.63Zm-44.86,7.16a8.15,8.15,0,0,0,1.3-1.66,8.88,8.88,0,0,0-3,3A8.2,8.2,0,0,0,359.28,234.79Zm26.78-34.47a8.2,8.2,0,0,0,1.31-1.66,7.93,7.93,0,0,0-1.66,1.31,8.2,8.2,0,0,0-1.31,1.66A8.2,8.2,0,0,0,386.06,200.32Zm-6.64,44.9a7.93,7.93,0,0,0,1.31-1.66,7.93,7.93,0,0,0-1.66,1.31,8.2,8.2,0,0,0-1.31,1.66A8.2,8.2,0,0,0,379.42,245.22Zm0-27a7.62,7.62,0,0,0,1.31-1.66,9,9,0,0,0-3,3A7.93,7.93,0,0,0,379.44,218.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.82,184.12c-.14,1-4.12,7.5-8.46,7.67-1.42.05-2.05-7.65-2.05-7.65l-.18-.56-2.47-7.81L365.5,169l1.29-.91s.53,2.19,1.17,4.91l.09.39c0,.15.08.29.11.44l.3,1.23c.07.32.14.63.2,1l.21,1A52.09,52.09,0,0,1,369.82,184.12Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,173a16.41,16.41,0,0,1-8.83,10.63l-2.47-7.81L365.5,169l1.29-.91S367.32,170.23,368,173Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.7,164c-.07,14.38,8.54,16.05,11.64,16.06,2.81,0,12.4-.31,14-14.61s-5.11-18.87-11.54-19.24S345.77,149.59,345.7,164Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.51,166.42c-2.35.24-3-4.69-3-4.69s-4.79.14-6.54-6.72a10.61,10.61,0,0,0,2.26,5.65S354.74,160,351,153c0,0,1.51,3.57,2.87,4.82a10,10,0,0,1-5.37-3.74s-1.38,4.12-2.49,5.27c0,0-1.64-7.24,1.37-11,6.34-8,16.75-1,16.75-1s5.82.88,7.9,5.24C375.24,159.26,370.51,166.42,370.51,166.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,166.51s2.76-4.73,4.89-3.78.3,7.63-2,8.71a2.43,2.43,0,0,1-3.35-1Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.32,164.63a0,0,0,0,1,0,.07,6.16,6.16,0,0,0-2.85,4.09,1.34,1.34,0,0,1,2-.53c.05,0,0,.1,0,.09a1.48,1.48,0,0,0-1.59.66,6.89,6.89,0,0,0-.68,1.39c-.07.15-.34.1-.3-.08v0C369.63,168.15,371.05,165,373.32,164.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.5,161.09a8.08,8.08,0,0,0,1-.24,1.62,1.62,0,0,0,.94-.44.51.51,0,0,0,0-.63,1.29,1.29,0,0,0-1.27-.25,1.89,1.89,0,0,0-1.15.71A.55.55,0,0,0,347.5,161.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.88,162.21a8.5,8.5,0,0,1-1-.16,1.62,1.62,0,0,1-1-.37.5.5,0,0,1,0-.63,1.25,1.25,0,0,1,1.24-.34,1.94,1.94,0,0,1,1.21.61A.55.55,0,0,1,356.88,162.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,165.15s.07,0,.07.09c0,1,.13,2.12,1,2.43a0,0,0,0,1,0,.06C355,167.59,354.79,166.09,355,165.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.83,164.11c1.58-.15,1.76,3,.29,3.17S354.5,164.23,355.83,164.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.46,164.24c.29.17.58.47.92.49s.66-.34.9-.67c0,0,.05,0,.05,0,0,.61-.16,1.25-.8,1.38s-1-.4-1.24-1C356.26,164.35,356.35,164.18,356.46,164.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.49,165.2s-.08.05-.07.09c.09,1,0,2.13-.84,2.51,0,0,0,.06,0,0C349.67,167.63,349.73,166.12,349.49,165.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.54,164.23c-1.59,0-1.51,3.16,0,3.18S349.88,164.25,348.54,164.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.89,164.45c-.25.18-.49.49-.79.52s-.62-.31-.85-.64c0,0-.05,0-.05,0,0,.61.22,1.24.81,1.34s.91-.44,1-1.05C348.08,164.55,348,164.38,347.89,164.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.22,173.19c-.21.26-.41.6-.77.66a2.5,2.5,0,0,1-1.08-.14,0,0,0,0,0,0,.06,1.3,1.3,0,0,0,1.29.4,1,1,0,0,0,.69-.94C356.33,173.17,356.25,173.16,356.22,173.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.14,169.56S351,171,351,171.73a14.94,14.94,0,0,1,4,.42c.31.09.29-.17-.06-.36a6,6,0,0,0-3.41-.69c-.05-.19.26-2.27.15-2.27a5.87,5.87,0,0,0-1.56.42c.2-3.09.9-6.13,1.05-9.21a.09.09,0,0,0-.18,0,50.36,50.36,0,0,0-1.56,9.86C349.46,170.27,350.87,169.69,351.14,169.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.63,171.73a3.81,3.81,0,0,0,2,1.36c1.21.12,1.29-1-.06-1.51A3.61,3.61,0,0,0,352.63,171.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.65,173.09a2.51,2.51,0,0,1-1.23-.58c.22-.39.78-.83,2.1-.2C355.73,172.77,355.42,173.17,354.65,173.09Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.71,182.4c1.76,0,4.72.44,8.72,3.48,0,0-8.34,6.71-16.1,6.71-2.77,0-3.6-3.87-3.6-3.87S360.46,182.46,367.71,182.4Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.46,470.32H466.79c-23.74,0-38.26-16.41-40.87-46.2-1.29-14.69-2.08-32.47-2.91-51.29-2.56-57.83-6.07-137-28.58-137H368.56v-6h25.87c28.24,0,31.46,72.57,34.57,142.75.83,18.76,1.62,36.48,2.9,51,1.63,18.58,9,40.73,34.89,40.73h32.67Z",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.56 229.81 386.28 235.81 368.56 235.81 368.56 229.81 387.56 229.81",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.34,
    y: 196.9,
    width: 10.46,
    height: 73.09,
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.58,
    y: 202.3,
    width: 39.77,
    height: 61.54,
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.34 202.31 309.34 263.85 299.46 263.85 295.03 202.31 309.34 202.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.06,213.35h30.51a0,0,0,0,1,0,0v9.2a0,0,0,0,1,0,0H239.06a3.94,3.94,0,0,1-3.94-3.94V217.3A3.94,3.94,0,0,1,239.06,213.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 213.35,
    width: 10.71,
    height: 9.19,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.06,243.6h30.51a0,0,0,0,1,0,0v9.2a0,0,0,0,1,0,0H239.06a3.94,3.94,0,0,1-3.94-3.94v-1.31A3.94,3.94,0,0,1,239.06,243.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 243.6,
    width: 10.71,
    height: 9.19,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.54,
    y: 227.2,
    width: 31.07,
    height: 12.27,
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.54,
    y: 227.21,
    width: 31.07,
    height: 12.27,
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.45 227.21 360.43 239.48 350.54 239.48 350.54 227.21 361.45 227.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.8,204.62h24.59a6.15,6.15,0,0,1,6.15,6.15v44.61a6.15,6.15,0,0,1-6.15,6.15H319.8a0,0,0,0,1,0,0V204.62A0,0,0,0,1,319.8,204.62Z",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.88 204.62 328.45 261.53 319.81 261.53 319.81 204.62 332.88 204.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 328.63,
    y: 216.12,
    width: 1.96,
    height: 33.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 334.19,
    y: 216.12,
    width: 1.96,
    height: 33.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 339.75,
    y: 216.12,
    width: 1.96,
    height: 33.9
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M378.73,192.87c3.44,9.65-1.49,45-7.32,52.49-8.66,11.1-25.77,21.31-32.31,24.5-2.86,1.39-15.67-19.09-12.88-21,6-4.11,25.11-13.92,26.73-15.87s10.34-20.68,13.83-31.21C371.47,187.64,377,188,378.73,192.87Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.08,269.92c-9.07,5.18-27.12,4.42-29.58,3.67l-3.18-1c-3.79-1.07-4.81-3.16-4.81-3.16s-4.74.06-5.26-2.8c-.58-3.21,6.19-2.67,10.1-4.65,9-4.53,20.42-13.49,22.87-15.05Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.08,263.84a62.81,62.81,0,0,1-8.07,3.53,65.86,65.86,0,0,1-9.43,2,.08.08,0,0,0,0,.15,34.25,34.25,0,0,0,17.61-5.44C319.32,264,319.21,263.78,319.08,263.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.6,268.85c-2.66,1.1-7.35,3-16.29,3.66,0,0,0,.05,0,.06a30.68,30.68,0,0,0,16.39-3.45C322.86,269,322.78,268.78,322.6,268.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8,255.85c.93-1,.38-1.54-2.08-1.1s-11.81,4.3-12.88.93,12.21-8.63,16.36-9.06a69.46,69.46,0,0,1,11.24.33C327.06,248.49,321.42,252.77,316.8,255.85Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.08,195.3c6.05-12.73,11.57-9.36,12.1,3.23A200.33,200.33,0,0,1,380,224.71l-21.93-6.28S365.21,203.45,369.08,195.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.54,187.88a9,9,0,0,1,3,3,9,9,0,0,1-3-3ZM365.85,204a7.94,7.94,0,0,0,.25,2.1,7.94,7.94,0,0,0,.25-2.1,7.81,7.81,0,0,0-.25-2.09A8.24,8.24,0,0,0,365.85,204Zm11.32,2.47a8.37,8.37,0,0,0-2.1.25,8.95,8.95,0,0,0,4.2,0A8.37,8.37,0,0,0,377.17,206.45ZM363.9,216.71a8.2,8.2,0,0,0,1.66,1.31,9,9,0,0,0-3-3A8.2,8.2,0,0,0,363.9,216.71Zm15.54,1.48a7.62,7.62,0,0,0,1.31-1.66,9,9,0,0,0-3,3A7.93,7.93,0,0,0,379.44,218.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,199.18c-.82,1.67-1.68,3.31-2.54,5q.22-1.17.36-2.37a0,0,0,0,0-.06,0c-.12.62-.27,1.24-.39,1.86-.05.3-.11.6-.17.9,0,.06,0,.12,0,.19-.67,1.28-1.33,2.57-2,3.87-.76,1.56-1.47,3.13-2.19,4.7s-1.39,3.49-2.2,5.08a10.76,10.76,0,0,0,2.14.64c.19.07.29-.12.09-.15s-1.84-.68-1.86-.69c.72-1.59,1.61-3.09,2.37-4.65s1.54-3.1,2.27-4.67c1.48-3.18,2.78-6.45,4.25-9.64C367.07,199.17,367,199.14,367,199.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.09,206.76c-.2.65-.43,1.3-.6,2-.06.28-.13.55-.2.83q.12-3.42.22-6.82s0,0,0,0c-.31,3.72-.63,7.43-.87,11.15a103.8,103.8,0,0,0-.49,10.72,12.85,12.85,0,0,0-2-.31,9.63,9.63,0,0,0,2.27.65c.55-3.6.59-7.58.77-11.2.05-1,.08-2,.12-3.07.12-.63.3-1.25.47-1.87s.3-1.34.44-2C382.17,206.74,382.1,206.72,382.09,206.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.11,221.39c-3.09-1.1-15.89-5.14-18.71-5.83-.2-.05-.28.06-.08.13a177.91,177.91,0,0,0,18.74,5.81C379.14,221.53,379.19,221.41,379.11,221.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.6,218c3,.92,2.39-3.18,2.39-3.18s2.35,5.68,5.84,5.43,2.41-5.18,2.35-5.54c.12.3,2.42,5.46,5.9,4.85s1.81-5.43,1.69-5.73c.21.24,3,3.43,5.56,2.36,4.36-1.84-2.6-10.2-2.09-14l6.13.18a5.77,5.77,0,0,0,.6-.09l.23-3.13a39.9,39.9,0,0,1-5.66-2.84c-2.31-1.3-4.54-2.48-6.2-2.52a3.47,3.47,0,0,0-3.45,2.29s-1.8-2.84-4.56-2.44c-1.41.21-2.33,2.66-2.33,2.66a4.15,4.15,0,0,0-4-1.71c-1.94.4-2.56,2.8-2.56,2.8s-2.46-1.45-4.31-.39C263.42,199.06,265.12,216,271.6,218Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,201.83l5.34.49a5.77,5.77,0,0,0,.6-.09c6.74-1.22,10.94-8.94,6-9.49-3.71-.43-7.73,4.5-11.48,3.51h0Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.31,197.7a0,0,0,0,0-.09,0A29.45,29.45,0,0,0,274,215c.09.17.4.09.34-.11A60.17,60.17,0,0,1,271.31,197.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,196.17c0-.07-.11-.07-.12,0A27.59,27.59,0,0,0,282,214.86c.13.19.44.23.3,0C280.08,211,278,201.66,278,196.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.17,214.07c-3.45-5.44-4.82-11.44-5.33-17.8,0-.08-.12-.06-.14,0-.59,3.18.16,7.2,1,10.28a17,17,0,0,0,4.27,7.63C290.07,214.27,290.25,214.19,290.17,214.07Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.7,442c-2.07.69-61.34.52-63.6-.91-.85-.54-1.33-9.18-1.61-19.63-.07-2.25-.11-4.58-.15-6.95,0-2.8-.08-5.64-.1-8.4-.07-12.38.1-23.28.1-23.28h38.59l0,23.28v8.4l-.2,6.95s22.66,10.22,25,12.06S207.77,441.36,205.7,442Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.7,442c-2.07.69-61.34.52-63.6-.91-.85-.54-1.33-9.18-1.61-19.63-.07-2.25-.11-4.58-.15-6.95,0-2.8-.08-5.64-.1-8.4h38.67v8.4l-.2,6.95s22.66,10.22,25,12.06S207.77,441.36,205.7,442Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.88,442.13c-1.35.45-26.59.54-45,.16-4.26-.1-8.15-.21-11.28-.35-4.33-.2-7.23-.43-7.7-.73-1.05-.67-1.54-13.35-1.78-26.73h38.77l-.2,7s22.79,10.28,25.11,12.13S208,441.43,205.88,442.13Z",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,439.75c-10-.28-50.3-.44-60.2.05-.08,0-.08.05,0,.06,9.9.49,50.21.32,60.2.05C205.24,439.9,205.25,439.75,205,439.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.14,419.26c-3.93-.74-8.74-.15-11.75,2.64-.12.11,0,.27.17.23a54.78,54.78,0,0,1,11.57-2.37A.25.25,0,0,0,180.14,419.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,421c-3.93-.75-8.74-.16-11.76,2.64-.11.1,0,.27.17.23A54.91,54.91,0,0,1,183,421.48.25.25,0,0,0,183,421Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,422.7c-3.93-.75-8.74-.16-11.75,2.63-.12.11,0,.28.16.24a55.7,55.7,0,0,1,11.57-2.38A.25.25,0,0,0,185.81,422.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,424.42c-3.93-.75-8.74-.16-11.75,2.63-.12.11,0,.28.17.24a54.83,54.83,0,0,1,11.56-2.38A.25.25,0,0,0,188.64,424.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.43,410.19c-1.54-2.13-4.42-1.18-6.06.19a21,21,0,0,0-6.08,9,.1.1,0,0,0,.09.14c0,.3.28.62.61.49,3.25-1.19,6.88-2.06,9.66-4.22C187.28,414.53,188.89,412.21,187.43,410.19Zm-6.88,7c-1.58.62-3.19,1.17-4.75,1.85a62,62,0,0,1,3.67-5.17,21.07,21.07,0,0,1,2.09-2.24c1.17-1.07,5.81-3.32,5.1,1C186.27,415,182.44,416.44,180.55,417.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.3,418.31c3.23,1.39,7,1.33,10.4,1.68a.5.5,0,0,0,.48-.63.1.1,0,0,0,0-.16A21,21,0,0,0,168.1,412c-1.94-.92-5-1.12-5.92,1.33S163.41,417.5,165.3,418.31Zm-1.77-2.8c-1.76-4,3.29-3,4.69-2.25a24.22,24.22,0,0,1,2.59,1.66,60.82,60.82,0,0,1,4.84,4.09c-1.68-.27-3.37-.4-5.06-.61C168.57,418.15,164.5,417.71,163.53,415.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.41,411.76l-47.82.86S130.08,370.31,125.8,344c-1.62-9.89-2.9-17.53-3.42-19.83-1.24-5.49-25.47-92.63-25.47-92.63l34.76-.05h11.88s-.76,14.57-.31,16.1c6.2,21.09,18.87,58.49,22.83,71.52C172.14,339.14,184.41,411.76,184.41,411.76Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.06,404.43c-6.86-.05-31.2-.32-40.34.53a.07.07,0,0,0,0,.13c3.15.45,33.48-.25,40.35-.47A.1.1,0,1,0,180.06,404.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.37,368.37q-2.48-16.41-5.53-32.74c-1-5.35-2.09-10.69-3.49-16s-3.18-10.56-5-15.77c-3.58-10.36-7-20.77-10.21-31.25s-6.2-21-9-31.61c-.36-1.34-.71-2.68-1.1-4,0-.11-.19-.06-.17,0,1.09,5.34,2.5,10.63,3.85,15.91s2.8,10.54,4.31,15.78q4.56,15.78,9.89,31.34c1.77,5.16,3.61,10.31,5.18,15.54s2.79,10.53,3.88,15.87c2.21,10.84,4.09,21.75,5.83,32.66s3.23,22,4.69,33c.19,1.39.37,2.79.55,4.19.05.39.67.39.63,0C140.55,390.32,139,379.33,137.37,368.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.67,231.47,125.8,344c-1.62-9.89-2.9-17.53-3.42-19.83-1.24-5.49-25.47-92.63-25.47-92.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.39,451.48c-2.07.69-61.34.52-63.6-.92-.85-.53-1.33-9.17-1.61-19.62-.07-2.26-.11-4.58-.15-6.95,0-2.81-.08-5.64-.1-8.4-.07-12.38.1-23.28.1-23.28h38.58V424l-.2,6.95s22.66,10.22,25,12.06S148.46,450.8,146.39,451.48Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.39,451.48c-2.07.69-61.34.52-63.6-.92-.85-.53-1.33-9.17-1.61-19.62-.07-2.26-.11-4.58-.15-6.95,0-2.81-.08-5.64-.1-8.4H119.6V424l-.2,6.95s22.66,10.22,25,12.06S148.46,450.8,146.39,451.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.57,451.57c-1.35.44-26.6.53-45,.15-4.25-.09-8.14-.21-11.28-.34-4.32-.2-7.22-.44-7.7-.74-1-.67-1.54-13.34-1.77-26.72h38.77l-.2,7S142.2,441.19,144.52,443,148.65,450.87,146.57,451.57Z",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.72,449.18c-10-.27-50.31-.44-60.2.05-.08,0-.08.06,0,.07,9.89.48,50.21.32,60.2.05C145.93,449.34,145.93,449.19,145.72,449.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83,428.7c-3.93-.75-8.74-.16-11.75,2.63-.12.11,0,.28.16.24a55.7,55.7,0,0,1,11.57-2.38A.25.25,0,0,0,120.83,428.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.66,430.42c-3.93-.75-8.74-.16-11.75,2.63-.12.11,0,.28.17.24a54.8,54.8,0,0,1,11.57-2.38A.25.25,0,0,0,123.66,430.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,432.13c-3.93-.74-8.74-.15-11.76,2.64-.11.11,0,.27.17.23a55.54,55.54,0,0,1,11.57-2.37A.25.25,0,0,0,126.5,432.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33,433.85c-3.93-.74-8.74-.15-11.75,2.64-.12.11,0,.27.16.23a55.68,55.68,0,0,1,11.57-2.37A.25.25,0,0,0,129.33,433.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.12,419.63c-1.54-2.14-4.42-1.19-6.07.19a21,21,0,0,0-6.08,9,.11.11,0,0,0,.1.14.48.48,0,0,0,.61.49c3.25-1.19,6.87-2.06,9.66-4.22C128,424,129.57,421.64,128.12,419.63Zm-6.88,7c-1.59.63-3.19,1.17-4.75,1.86,1.19-1.75,2.3-3.54,3.66-5.17a23.48,23.48,0,0,1,2.09-2.25c1.18-1.06,5.81-3.31,5.11,1C127,424.44,123.13,425.88,121.24,426.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,427.75c3.24,1.39,7,1.33,10.41,1.68a.49.49,0,0,0,.47-.64.11.11,0,0,0,.06-.16,21.09,21.09,0,0,0-8.13-7.18c-1.94-.92-5-1.12-5.92,1.33S104.09,426.94,106,427.75Zm-1.76-2.81c-1.76-4,3.29-3,4.69-2.24a22.67,22.67,0,0,1,2.59,1.65,63.13,63.13,0,0,1,4.84,4.1c-1.69-.28-3.38-.4-5.07-.61C109.26,427.59,105.19,427.15,104.22,424.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,420.63H78.21s10.17-145.08,8.53-153.21c-2.69-13.31-.9-28.6,5.4-36h41.63s.83,11.68-3.47,18.66c0,0-3.91,2.47-5.8,3.56Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.64,413.06c-6.48-.16-4.61-.21-11.1-.3-3.17-.05-24-.34-27,.13-.07,0-.07.12,0,.13,3,.51,23.82.44,27,.42,6.48,0,4.62-.09,11.1-.19A.1.1,0,0,0,120.64,413.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,248.25a80,80,0,0,0-11.71,6.93.13.13,0,0,0,.14.23c4-2.19,8-4.31,11.84-6.71A.26.26,0,0,0,132.9,248.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.59,247.65a20.39,20.39,0,0,0-.56,2.46,5.31,5.31,0,0,0-.13,2c0,.13.21.12.27,0a6.92,6.92,0,0,0,.64-2c.2-.77.42-1.53.59-2.3C128.52,247.32,127.75,247.15,127.59,247.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.22,243.64c.11-.7.22-1.39.35-2.08s.31-1.44.38-2.16c0-.12.2-.08.18,0-.11.7-.12,1.42-.18,2.12s-.12,1.41-.19,2.11a39.67,39.67,0,0,1-.62,3.93,4.72,4.72,0,0,0,1.92-.79,3.7,3.7,0,0,0,1-2c.2-.8.38-1.6.59-2.4a15.09,15.09,0,0,0,.61-2.66c0-.12.2-.08.18,0a28.19,28.19,0,0,1-1.06,5.61,3.08,3.08,0,0,1-1.05,1.86,6.05,6.05,0,0,1-2.33.69c-.09,0-.23,0-.22-.11A41.66,41.66,0,0,1,127.22,243.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5,266.89c-.3-3.06-.8-6.1-1.13-9.16a57,57,0,0,1,1.1-18.32c0-.11-.15-.16-.17,0a68,68,0,0,0-1.64,16.08c.27,5.4,1.23,10.72,1.31,16.13s-.34,10.95-.69,16.41-.71,11-1.06,16.49c-1.42,22.09-2.73,44.18-4.08,66.28q-.56,9.24-1.08,18.5c-.36,6.27-.8,12.55-1,18.84,0,.54.78.5.83,0,.94-11.09,1.48-22.22,2.19-33.31s1.34-22,2-33,1.33-22,2-33q.48-8.24,1-16.48c.32-5.47.72-10.95.8-16.43A79.81,79.81,0,0,0,93.5,266.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24,239a.1.1,0,0,0-.17,0,7.23,7.23,0,0,0-.39,2.25,16.68,16.68,0,0,1-.57,2.42,9.65,9.65,0,0,1-2.5,4.2c-2.62,2.45-6.13,3.36-9.51,4.18a.11.11,0,0,0,0,.21,15.05,15.05,0,0,0,5.9-.92,12.27,12.27,0,0,0,4.55-2.55,8.46,8.46,0,0,0,2.46-4.45,14.3,14.3,0,0,0,.28-2.7c0-.43,0-.86,0-1.3A3.43,3.43,0,0,0,108.24,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84,182.88c.86,6.8,14.18,32.08,28.36,43.28,5.2,4.11,32.77,6.54,39.67,6,8.07-.62,9.28-19.83,4.76-21.33-5.65-1.87-31.79-4.18-36.92-6-6.24-2.26-17.6-16.77-28.4-25.75C129.76,174.43,127.18,177.65,127.84,182.88Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.87,232.17c2.55-.07,14.22-1.41,17.39-2.51s12-4.92,11.44-7.43-3.28-1.6-3.28-1.6,3.49-2.21,2.66-4.68-5-.91-5-.91,3.42-2.53,2.41-4.94-4.9-.14-4.9-.14,3.24-2.17,1.58-3.81c-2-2-7.52,2.71-11.1,3.66-.82.22-16.82,3.21-16.82,3.21Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,209.77c-4.07,3.42-6.44,4.22-11.62,4.93a.09.09,0,0,0,0,.17c5.13-.24,8.25-.81,11.79-4.91C217.32,209.76,217.16,209.61,217,209.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.43,214.76C214.9,218,212.34,218.83,207,220c-.07,0-.05.15,0,.14,5.36-.69,8.46-1.33,12.57-5.11C219.74,214.84,219.64,214.61,219.43,214.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.14,220.68c-4.61,2.77-7.38,3.86-12.74,4.31a.1.1,0,0,0,0,.2,17.85,17.85,0,0,0,12.8-4.36C221.47,220.62,221.43,220.51,221.14,220.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.55,210.92a65.62,65.62,0,0,1,8.43-4.61c2.82-1,14.72-1,14.85,1.58.18,3.32-6.69,4.65-10.14,4.87,0,0,.43,7.67-4.3,9.7S186.55,210.92,186.55,210.92Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.59,208.82c-2,3.14-6.57,3.13-9.9,3.59a.3.3,0,0,0-.25.44c0,3.23-1,7.77-3.85,9.68-.09.06,0,.19.07.14,3.31-1.64,4.65-6,4.46-9.57,3.42-.41,8-.6,9.5-4.27C209.63,208.81,209.6,208.8,209.59,208.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.05,231.8s-14.12-3.86-15.84-5.21a61.76,61.76,0,0,1-5.36-4.74C138,209.22,130.24,192,128.14,186c-2.22-6.39-.18-12.51,5.77-8.39a16.74,16.74,0,0,1,1.38,1.09c7,6.1,25.72,24.65,28,25.6s13.27,2.39,13.27,2.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.85,221.85C138,209.22,130.24,192,128.14,186c-2.22-6.39-.18-12.51,5.77-8.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,206.25a52.43,52.43,0,0,0-1.63,5.89c-.49,2-1,4-1.41,6a106.62,106.62,0,0,0-2,11.89.09.09,0,0,0,.18,0c1.08-3.92,1.88-7.93,2.7-11.91.41-2,.78-3.94,1.19-5.9s.9-4,1.12-5.94A.06.06,0,0,0,172,206.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.54,196.73c.33,1.48.59,3,.79,4.56a1.1,1.1,0,0,1,0-.18c.08-.85.14-1.72.29-2.56,0,0,.08-.05.08,0a13.21,13.21,0,0,1-.1,2.59c-.05.41-.1.82-.16,1.22.07.69.13,1.38.17,2.06.08,1.3.33,6.85.3,7.8,0,.2-.23.22-.28,0-.19-1-.69-6.69-.83-8a69.87,69.87,0,0,1-.38-7.52C141.44,196.67,141.52,196.68,141.54,196.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.13,238.27c-2,1.8-4.44,4.43-18.48,5.41-.88,0-1.78.07-2.68,0-13.52-.38-32.49-11-33.62-11.84,0,0,14.57-39.42,33.84-54.55,2.75-2.17,8.65-1.1,12.34,1.13,1.32.8,5.68,8.09,6.56,14.73S145.12,236.47,143.13,238.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.18,188.3c-3.4.28-8.27-5.6-9.87-10-.11-.3.77-3.17,1.67-6.71.54-2.15,1.09-4.55,1.43-6.78.07-.46,1.5.62,1.5.62l2.78,1.14,9.2,3.78a35.83,35.83,0,0,0-2.67,8.36,5,5,0,0,0,0,.94.86.86,0,0,1,0,.15C136.19,181.57,135.46,188,132.18,188.3Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,179.64a.86.86,0,0,1,0,.15,8.73,8.73,0,0,1-1.45-.14C125.33,178,126,165.83,126,165.83l3.7.73,9.2,3.78a35.83,35.83,0,0,0-2.67,8.36A5,5,0,0,0,136.18,179.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.46,150.16c-1.79,4.94.12,19.56,3.52,23,4.93,5,13.38,5.83,17.67-.19,4.17-5.82,1.34-24.84-2.49-28C137.51,140.34,127.1,142.87,124.46,150.16Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.78,160.28s-.07.06-.06.1c.15,1,.17,2.13-.69,2.57,0,0,0,.06,0,.05C138.12,162.71,138.09,161.18,137.78,160.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.77,159.36c-1.6.08-1.32,3.27.16,3.2S138.11,159.29,136.77,159.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.84,159.62s.08,0,.08.08c.06,1,.29,2.12,1.21,2.38a0,0,0,0,1,0,0C144,162.07,143.73,160.57,143.84,159.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64,158.51c1.58-.25,2,2.93.51,3.17S143.31,158.73,144.64,158.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.53,157c.42-.15.79-.36,1.2-.55a2.1,2.1,0,0,0,1.11-.78.67.67,0,0,0-.17-.81,1.71,1.71,0,0,0-1.71,0,2.44,2.44,0,0,0-1.32,1.19A.72.72,0,0,0,135.53,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.64,157.43a11.38,11.38,0,0,1-1.3-.22,2.13,2.13,0,0,1-1.28-.48.68.68,0,0,1,0-.82,1.65,1.65,0,0,1,1.64-.46,2.48,2.48,0,0,1,1.59.81A.73.73,0,0,1,145.64,157.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.71,169.21c.25.21.52.51.88.51a2.66,2.66,0,0,0,1-.34,0,0,0,0,1,.05.05,1.35,1.35,0,0,1-1.21.64,1.06,1.06,0,0,1-.86-.8C137.59,169.21,137.67,169.18,137.71,169.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.45,165a21.3,21.3,0,0,1,.19,2.17,15,15,0,0,0-4,.56c-.3.1-.3-.16,0-.36a5.85,5.85,0,0,1,3.38-.81c0-.19-.34-2.26-.23-2.27a6.22,6.22,0,0,1,1.57.37c-.31-3.08-1.11-6.09-1.38-9.16,0-.11.15-.15.18-.05a49.46,49.46,0,0,1,1.91,9.81C144.16,165.65,142.73,165.11,142.45,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.52,162.35c2.52-.18,2.2-6.34,2.2-6.34s3.84-.74,5.65-6c0,0,5,3,9.13,2.24,6.48-1.26,6.2-9.71,3.75-11.4-3.48-2.4-9.58,1.23-9.58,1.23s-9.32-2.47-12,3.85a4.77,4.77,0,0,0-4.38,4.81C120.05,155.29,123.65,162.48,125.52,162.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.83,156.75a8.52,8.52,0,0,0,4.82-2.72,6.35,6.35,0,0,0,1.41-5.7.09.09,0,0,1,.17,0,7.34,7.34,0,0,1-1,6.18,6,6,0,0,1-5.42,2.46C126.75,156.92,126.72,156.77,126.83,156.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,148c1.26-1.64,3.21-1.91,5.14-1.87.11,0,.11.18,0,.17a5.38,5.38,0,0,0-4.78,2.67c-1,1.54-.71,3.45-.3,5.13a13.57,13.57,0,0,0,5.49,8,0,0,0,1,1,0,.07,13.48,13.48,0,0,1-6.16-8.73C118.92,151.68,118.76,149.54,119.92,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.42,142.36a6.38,6.38,0,0,1,3.54-2.78,7.59,7.59,0,0,1,5.4.48,4.3,4.3,0,0,1,2.3,3.63,7.61,7.61,0,0,1-1.65,4.82s-.09,0-.06,0a7.5,7.5,0,0,0,1.27-4.38,3.93,3.93,0,0,0-2.36-3.46c-2.68-1.15-6.58-.91-8.3,1.82C136.51,142.55,136.36,142.45,136.42,142.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,162.12s-3.13-4.79-5.3-3.68.1,8,2.57,9a2.54,2.54,0,0,0,3.44-1.26Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35,160.39s0,.05,0,.07a6.41,6.41,0,0,1,3.19,4.12,1.4,1.4,0,0,0-2.09-.45s0,.1,0,.09a1.56,1.56,0,0,1,1.7.6,7.53,7.53,0,0,1,.78,1.42c.08.16.36.08.31-.1v0C126.38,163.87,124.74,160.69,122.35,160.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.67,470.32H0v-6H32.67c25.88,0,33.26-22.15,34.89-40.73,1.28-14.55,2.06-32.27,2.89-51,3.11-70.18,6.33-142.75,34.57-142.75H130.9v6H105c-22.5,0-26,79.19-28.57,137-.84,18.83-1.63,36.61-2.91,51.3C70.92,453.91,56.41,470.32,32.67,470.32Z",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.9 229.81 130.9 235.81 110.26 235.81 108.98 229.81 130.9 229.81",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.68,
    y: 194.58,
    width: 11.02,
    height: 76.98,
    transform: "translate(452.38 466.15) rotate(180)",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.8,
    y: 198.24,
    width: 41.88,
    height: 68.88,
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.68 198.24 220.68 267.12 210.28 267.12 205.61 198.24 220.68 198.24",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.36,
    y: 226.68,
    width: 31.07,
    height: 12.27,
    transform: "translate(261.79 465.62) rotate(180)",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.36,
    y: 226.68,
    width: 31.07,
    height: 12.27,
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.52 238.94 136.54 226.68 146.43 226.68 146.43 238.94 135.52 238.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.43,203.11h26.22a6.15,6.15,0,0,1,6.15,6.15v47.64a6.15,6.15,0,0,1-6.15,6.15H146.43a0,0,0,0,1,0,0V203.11A0,0,0,0,1,146.43,203.11Z",
    transform: "translate(325.23 466.15) rotate(180)",
    style: {
      fill: "#B53322"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.02 263.04 169.69 203.11 178.8 203.11 178.8 263.04 165.02 263.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 167.44,
    y: 215.23,
    width: 2.07,
    height: 35.7,
    transform: "translate(336.94 466.15) rotate(180)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 161.58,
    y: 215.23,
    width: 2.07,
    height: 35.7,
    transform: "translate(325.23 466.15) rotate(180)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 155.73,
    y: 215.23,
    width: 2.07,
    height: 35.7,
    transform: "translate(313.52 466.15) rotate(180)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M113.45,191.15c-1,14.44-2.14,43.85,4.24,52.48,8.37,11.32,32,18.19,39,20.25,3,.89,10.19-19,8.41-21.86s-26.17-9-28.09-10.68-8-25.12-10.89-37.06C122.38,179.22,113.86,185.45,113.45,191.15Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.12,249.66c3.85.92,9.69-1.06,9.88,1.89.17,2.62-4,3.59-4,3.59s5.06.43,4.44,3.3-5.42,3-5.42,3,4.64.63,3.81,3.45-5.28,3.21-5.28,3.21,1.17.87-.31,2.6c-2.11,2.48-9.15,2.19-12.78,1.17s-16.2-7.46-18.11-8.49l6.37-23.4s7.31-1.16,11.09-1.3,16.35,2.86,15.82,6-9.38.9-11.67.82-2.69.43-1.69,1.27C175.92,247.36,181.41,249.25,183.12,249.66Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.77,255.09c-5.91,1-8.67.34-14.09-2-.11-.05-.2.1-.09.16,5.1,2.75,8.45,4,14.24,2.11C189.12,255.28,189.06,255.05,188.77,255.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.25,261.34c-6.23.45-9.22-.18-15.08-2.2-.08,0-.14.11-.06.15,5.59,2.45,8.95,3.64,15.12,2.37C188.51,261.61,188.54,261.32,188.25,261.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.47,268.06c-6.07,0-9.38-.56-14.82-3.24a.11.11,0,0,0-.11.19c5.28,3.28,9.41,4,14.91,3.24C186.82,268.19,186.85,268.06,186.47,268.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.24,259.19s-19.07-9.58-22-16.92c-3.6-9.16-5.07-35.87-3.67-49.57s10.94-12,14,.11c3,11.82,9.77,35.43,10.47,36.54.89,1.43,11.77,4.12,11.77,4.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.33,226.29c-.33-1.13-.91-3.68-1.24-4.78-.67-2.2-1.34-4.41-2-6.61s-1.37-4.41-2.1-6.6c-.13-.37-.25-.75-.37-1.12.06-.24-.21-3.14-.19-3.85,0-.11-.18-.12-.17,0a15.17,15.17,0,0,1-.07,2.13c0,.13,0,.27,0,.4-.46-1.44-.92-2.87-1.39-4.27,0-.1-.2-.06-.17,0,.9,3,1.34,4.89,2,7.32s1.34,4.69,2,7,1.43,4.66,2.16,7a42.83,42.83,0,0,0,1.44,4.09C136.65,227.9,136.67,227.48,136.33,226.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.82,234.36c-.39-2.47-.78-5-1.08-7.44-.61-5-1-9.92-1.22-14.92-.13-2.86-.34-5.7-.5-8.55a.11.11,0,0,0-.22,0c0,2.54-.09,5.07,0,7.61,0,.37,0,.74,0,1.11l-.12-.52c-.37-1.45-.89-2.87-1.21-4.34a.08.08,0,0,0-.15.05c.36,1.46.55,3,.89,4.43.18.73.36,1.46.56,2.19l.1.31c.06,1.46.13,2.92.23,4.38a122.91,122.91,0,0,0,1.73,14.94,59,59,0,0,0,2.61,9.49.08.08,0,0,0,.15,0C116,240.63,115.22,236.83,114.82,234.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.27,233.46a51.62,51.62,0,0,0-2.8,5.56c-.88,1.88-1.77,3.76-2.6,5.66a110,110,0,0,0-4.41,11.48.1.1,0,0,0,.18.07c1.86-3.7,3.45-7.55,5.07-11.36.8-1.88,1.57-3.78,2.36-5.66s1.69-3.77,2.3-5.71C145.39,233.44,145.3,233.41,145.27,233.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-404--inject-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.92,135.36a.29.29,0,0,1,.42,0,5.29,5.29,0,0,0,3.14,1.23,3.55,3.55,0,0,0,2.09-.63,1.75,1.75,0,0,0,.82-1.42,1.55,1.55,0,0,0-.77-1.31,6.44,6.44,0,0,0-2.21-.77h0a5.92,5.92,0,0,1-2.25-.81,2,2,0,0,1-1-1.66,2.21,2.21,0,0,1,1-1.78,3.88,3.88,0,0,1,2.3-.7,5.28,5.28,0,0,1,2.94,1.11.29.29,0,0,1,.08.42.29.29,0,0,1-.41.08,4.69,4.69,0,0,0-2.61-1,3.41,3.41,0,0,0-1.95.57,1.66,1.66,0,0,0-.75,1.31,1.37,1.37,0,0,0,.71,1.16,5.5,5.5,0,0,0,2,.72h0a6.69,6.69,0,0,1,2.43.87,2.17,2.17,0,0,1,1,1.8,2.39,2.39,0,0,1-1.08,1.91,4.21,4.21,0,0,1-2.45.75,5.92,5.92,0,0,1-3.52-1.38A.31.31,0,0,1,163.92,135.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.62,127.47a4.85,4.85,0,1,1-4.6,4.84A4.7,4.7,0,0,1,177.62,127.47Zm0,9a4.17,4.17,0,0,0,0-8.33,4.17,4.17,0,0,0,0,8.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.76,135a1.7,1.7,0,0,0-.78-1.44,3.07,3.07,0,0,0-1.1-.48l-.07,0H185.5v3.77a.34.34,0,0,1-.67,0v-8.88a.34.34,0,0,1,.3-.33h2.72A2.72,2.72,0,0,1,189,132.8l.13.07a2.41,2.41,0,0,1,1.29,2.12,3.7,3.7,0,0,0,.12,1.11.5.5,0,0,0,.13.23.33.33,0,0,1,.15.65.9.9,0,0,1-.16,0h0a.77.77,0,0,1-.61-.44A3.4,3.4,0,0,1,189.76,135Zm-1.91-6.71H185.5v4.11h2.41a2.06,2.06,0,0,0-.06-4.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,135a1.72,1.72,0,0,0-.78-1.44,3.14,3.14,0,0,0-1.1-.48l-.07,0H194v3.77a.34.34,0,0,1-.67,0v-8.88a.34.34,0,0,1,.3-.33h2.73a2.72,2.72,0,0,1,1.14,5.19l.14.07a2.4,2.4,0,0,1,1.28,2.12,3.7,3.7,0,0,0,.12,1.11.47.47,0,0,0,.14.23.37.37,0,0,1,.37.22.36.36,0,0,1-.22.43,1.09,1.09,0,0,1-.17,0h0a.77.77,0,0,1-.62-.44A3.44,3.44,0,0,1,198.28,135Zm-1.91-6.71H194v4.11h2.41a2.06,2.06,0,0,0,0-4.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.32,132.57l-3.2-4.38a.35.35,0,0,1,.07-.46.31.31,0,0,1,.46.06l3,4.1,3-4.1a.32.32,0,0,1,.47-.06.33.33,0,0,1,.07.46L205,132.54v4.28a.33.33,0,0,1-.33.33.33.33,0,0,1-.33-.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.78,127.94a.34.34,0,0,1,.67,0v6.84a.34.34,0,1,1-.67,0Zm0,8.55a.34.34,0,0,1,.67,0v.33a.34.34,0,0,1-.67,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,127.94a.33.33,0,0,1,.33-.33h2.7a2.72,2.72,0,0,1,0,5.44l-2.36,0v3.75a.34.34,0,0,1-.67,0Zm3,4.46a2.09,2.09,0,0,0,2.06-2.07,2.06,2.06,0,0,0-2.06-2.05h-2.36v4.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66,134.68h-4.35l-.84,2.25a.34.34,0,0,1-.31.22l-.13,0a.34.34,0,0,1-.19-.43l3.31-8.85a.37.37,0,0,1,.33-.2.34.34,0,0,1,.33.2l3.31,8.85a.34.34,0,0,1-.18.43l-.12,0a.34.34,0,0,1-.31-.22Zm-4.1-.67h3.85l-1.92-5.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.26,132.85a.32.32,0,0,1-.34-.32.34.34,0,0,1,.34-.34h3a.33.33,0,0,1,.29.34v3.32a.37.37,0,0,1-.12.25,4.89,4.89,0,1,1-3.08-8.63,5,5,0,0,1,3.1,1.08.34.34,0,0,1,0,.46.35.35,0,0,1-.48.06,4.15,4.15,0,0,0-2.66-.93,4.17,4.17,0,1,0,2.52,7.52v-2.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.89,127.94a.33.33,0,0,1,.33-.33h4.91a.34.34,0,0,1,0,.67h-4.57v3.77h4a.34.34,0,0,1,0,.67h-4v3.76h4.57a.34.34,0,0,1,0,.67h-4.94a.34.34,0,0,1-.3-.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.75,129v7.81a.33.33,0,1,1-.65,0v-8.75a.32.32,0,0,1,.58-.28l5.78,8V128a.34.34,0,0,1,.67,0v8.79a.34.34,0,0,1-.34.33.3.3,0,0,1-.26-.13s0,0,0-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.06,127.47a4.85,4.85,0,1,1-4.6,4.84A4.71,4.71,0,0,1,270.06,127.47Zm0,9a4.17,4.17,0,1,0-3.94-4.17A4.06,4.06,0,0,0,270.06,136.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,128.28H276.3a.34.34,0,0,1,0-.67h6.4a.34.34,0,0,1,0,.67h-2.87v8.54a.33.33,0,0,1-.33.33.32.32,0,0,1-.32-.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.62,127.94a.33.33,0,0,1,.31-.33h4.94a.34.34,0,0,1,0,.67h-4.58v3.77h4a.34.34,0,1,1,0,.67h-4v4.1a.34.34,0,0,1-.67,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.77,127.47a4.85,4.85,0,1,1-4.6,4.84A4.7,4.7,0,0,1,301.77,127.47Zm0,9a4.17,4.17,0,0,0,0-8.33,4.17,4.17,0,0,0,0,8.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.57,127.94a.34.34,0,0,1,.67,0v5.35a3.19,3.19,0,1,0,6.37,0v-5.35a.34.34,0,0,1,.67,0v5.35a3.86,3.86,0,1,1-7.71,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.14,129v7.81a.34.34,0,0,1-.33.33.33.33,0,0,1-.33-.33v-8.75a.34.34,0,0,1,.12-.37.36.36,0,0,1,.47.09l5.77,8V128a.34.34,0,0,1,.67,0v8.79a.34.34,0,0,1-.34.33.3.3,0,0,1-.26-.13s0,0-.05-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.62,137.15h-.06a.34.34,0,0,1-.3-.33v-8.88a.33.33,0,0,1,.33-.33h1.78a4.77,4.77,0,1,1,0,9.54Zm1.75-.67a4.1,4.1,0,1,0,0-8.2h-1.44v8.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,100.92a5.1,5.1,0,0,1-5.19,5.1h-.92v7a5.1,5.1,0,0,1-10.2,0v-7H168.46a4.53,4.53,0,0,1-3.15-1.12,4.94,4.94,0,0,1-.83-7.13l34.29-42.63c.09,0,.09-.1.18-.19a1.18,1.18,0,0,0,.28-.37.88.88,0,0,0,.46-.28c.1-.09.28-.18.37-.28a1,1,0,0,1,.56-.18c.09-.19.18-.28.37-.28s.28-.09.56-.18a.54.54,0,0,0,.37-.1h1.57a.8.8,0,0,0,.47.1c.09.09.37.09.55.18s.28.09.37.09a5.07,5.07,0,0,0,.47.37c.18.1.27.19.46.28a.09.09,0,0,1,.09.1c.09,0,.28.09.28.18l.37.37c.09.09.19.28.28.37a2.86,2.86,0,0,1,.37.47.69.69,0,0,0,.19.37,3.54,3.54,0,0,1,.18.55c0,.09.09.28.09.37a1,1,0,0,1,.1.56c0,.18.09.28.09.46V95.82h.92A5.16,5.16,0,0,1,214,100.92Zm-16.31-28L179.21,95.82h18.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.19,85.72c.09-8.53,2.22-16.22,6.3-22.15,3.89-5.93,9.92-10.29,17.24-10.29,7.13,0,13.25,4.36,17.14,10.29s6.21,13.62,6.21,22.15-2.22,16.22-6.21,22.15-10,10.29-17.14,10.29c-7.32,0-13.35-4.45-17.24-10.29C228.41,101.94,226.28,94.15,226.19,85.72Zm36.6,0a30.83,30.83,0,0,0-4.44-16.5c-2.69-3.89-5.75-5.74-8.62-5.65-2.88-.09-6,1.76-8.81,5.65a30.83,30.83,0,0,0-4.45,16.5,30.44,30.44,0,0,0,4.45,16.4c2.78,4,5.93,5.75,8.81,5.75s5.93-1.76,8.62-5.75S262.79,92.3,262.79,85.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.67,100.92a5.11,5.11,0,0,1-5.2,5.1h-.92v7a5.1,5.1,0,0,1-10.2,0v-7H284.16A4.53,4.53,0,0,1,281,104.9a4.94,4.94,0,0,1-.83-7.13l34.29-42.63c.09,0,.09-.1.18-.19a1.18,1.18,0,0,0,.28-.37.88.88,0,0,0,.46-.28c.1-.09.28-.18.37-.28a1,1,0,0,1,.56-.18c.09-.19.18-.28.37-.28s.28-.09.56-.18a.54.54,0,0,0,.37-.1h1.57a.8.8,0,0,0,.47.1c.09.09.37.09.55.18s.28.09.37.09c.19.19.37.28.46.37s.28.19.47.28a.09.09,0,0,1,.09.1c.09,0,.28.09.28.18l.37.37c.09.09.19.28.28.37a2.86,2.86,0,0,1,.37.47.69.69,0,0,0,.19.37,3.54,3.54,0,0,1,.18.55c0,.09.09.28.09.37a1,1,0,0,1,.09.56c0,.18.1.28.1.46V95.82h.92A5.17,5.17,0,0,1,329.67,100.92Zm-16.32-28L294.91,95.82h18.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.16,181.71a.5.5,0,0,1-.5-.5V167.14a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v14.07A.5.5,0,0,1,250.16,181.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,188.45a.51.51,0,0,1-.44-.25l-7-12.19a.5.5,0,1,1,.86-.5l7,12.19a.49.49,0,0,1-.18.68A.47.47,0,0,1,224.7,188.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.38,288.77a.47.47,0,0,1-.25-.07A.49.49,0,0,1,217,288l7-12.18a.5.5,0,1,1,.87.5l-7,12.18A.5.5,0,0,1,217.38,288.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84,297.55a.5.5,0,0,1-.5-.5V283a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v14.07A.5.5,0,0,1,249.84,297.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.34,288.93a.5.5,0,0,1-.43-.25l-7-12.18a.5.5,0,1,1,.87-.5l7,12.18a.49.49,0,0,1-.18.68A.47.47,0,0,1,282.34,288.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.58,188.61a.47.47,0,0,1-.25-.07.49.49,0,0,1-.18-.68l7-12.19a.5.5,0,0,1,.86.5l-7,12.19A.52.52,0,0,1,275.58,188.61Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.46480e9073bbd612e1260da516d7afe5.svg";
export { ForwardRef as ReactComponent };